import { styled } from '@mui/material/styles';
import { mobileThreshold } from '../../../../../Constants/layoutValues';

export const EducationWrapper = styled('div')``;

export const EducationPanelWrapper = styled('div')`
	flex: 1;
	padding-top: 1.5rem;
	padding-left: 0.75rem;
	:first-of-type {
		padding-left: 0;
	}
	height: fit-content;
	max-height: fit-content;
	@media (max-width: ${mobileThreshold}px) {
		padding-left: 0;
		padding-right: 0;
	}
`;

export const EducationContentWrapper = styled('div')`
	display: flex;
	flex-direction: column;
	font-size: 1em;
	line-height: 1.4em;
	padding-bottom: 1rem;
	@media print {
		line-height: 1.5em;
	}
	@media (max-width: ${mobileThreshold}px) {
		margin-left: 0;
		margin-right: 0;
	}
`;

export const EducationItemWrapper = styled('div')`
	padding-top: 0.25em;
	padding-bottom: 0.25em;
	display: flex;
	flex-direction: row;
	@media print {
		padding-top: 0.25em;
		padding-bottom: 0.25em;
	}
	@media (max-width: ${mobileThreshold}px) {
		flex-direction: column;
	}
`;

export const EducationDegreeWrapper = styled('div')`
	font-family: montserratMedium;
	padding-right: 0.25rem;
`;

export const EducationUniversityWrapper = styled('div')`
	padding-right: 0.25rem;
`;

export const EducationLocationWrapper = styled('div')`
	padding-right: 0.25rem;
`;

export const EducationTimespanWrapper = styled('div')`
	padding-right: 0.25rem;
`;
